import { Injectable } from "@angular/core";
import { ContentPageMetaResolver, PageRobotsMeta, PageRobotsResolver, PageType } from "@spartacus/core";
import { Observable, of } from "rxjs";

@Injectable({
  providedIn: 'root'
})
export class MyContentPageMetaResolver extends ContentPageMetaResolver implements
PageRobotsResolver {

pageType = PageType.CONTENT_PAGE;
pageTemplate = 'StaticContentPageTemplate';

resolveRobots(): Observable<PageRobotsMeta[]> {
  return of(new Array(PageRobotsMeta.NOFOLLOW, PageRobotsMeta.NOINDEX));
}
}